import { lazy } from 'react';

const PublicHome = lazy(() => import('./Home'));

const SignIn = lazy(() => import('./SignIn'));
const SignOut = lazy(() => import('./SignOut'));

// -------

export const PublicApi = {
  login: '/auth/login',
  logout: '/auth/logout',
}

export const PublicRoutes = {
  home: '/',
  signin: '/signin',
  signout: '/signout',
};

export const PublicComponents = [
  { public: true, path: PublicRoutes.home, component: PublicHome },
  { public: true, path: PublicRoutes.signin, component: SignIn },
  { public: true, path: PublicRoutes.signout, component: SignOut },
];
